import { VersionBadge } from '@/components/VersionBadge';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Skeleton } from '@/components/ui/skeleton';
import { AppShell } from '@/components/layout/AppShell';
import { LoginPage } from '@/features/auth/LoginPage';
import { AccueilPage } from '@/features/accueil/AccueilPage';

// Découpage par route : l'assuré ne télécharge que le wizard, l'expert n'embarque pdf.js qu'à la demande
const DashboardPage = lazy(() => import('@/features/dashboard/DashboardPage').then((m) => ({ default: m.DashboardPage })));
const DossierPage = lazy(() => import('@/features/dossier/DossierPage').then((m) => ({ default: m.DossierPage })));
const VisitPage = lazy(() => import('@/features/visit/VisitPage').then((m) => ({ default: m.VisitPage })));
const AdminPage = lazy(() => import('@/features/admin/AdminPage').then((m) => ({ default: m.AdminPage })));
const ContratsPage = lazy(() => import('@/features/contrats/ContratsPage').then((m) => ({ default: m.ContratsPage })));
const DisposPage = lazy(() => import('@/features/settings/DisposPage').then((m) => ({ default: m.DisposPage })));
const ClientWizardPage = lazy(() => import('@/features/client-wizard/ClientWizardPage').then((m) => ({ default: m.ClientWizardPage })));
const AssistantPage = lazy(() => import('@/features/assistant/AssistantPage').then((m) => ({ default: m.AssistantPage })));
const QualificationPage = lazy(() => import('@/features/assistant/QualificationPage').then((m) => ({ default: m.QualificationPage })));
const AffectationPage = lazy(() => import('@/features/assistant/AffectationPage').then((m) => ({ default: m.AffectationPage })));

export function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Skeleton className="m-6 h-64" />}>
        <Routes>
          <Route path="/" element={<AccueilPage />} />
          <Route path="/declaration" element={<ClientWizardPage />} />
          <Route path="/connexion" element={<LoginPage />} />
          <Route element={<AppShell />}>
            <Route path="/espace" element={<Skeleton className="m-6 h-40" />} />
            <Route path="/assistant" element={<AssistantPage />} />
            <Route path="/assistant/mission" element={<QualificationPage />} />
            <Route path="/assistant/dossiers/:dossierId" element={<AffectationPage />} />
            <Route path="/expert" element={<DashboardPage />} />
            <Route path="/dossiers/:dossierId" element={<DossierPage />} />
            <Route path="/dossiers/:dossierId/visite" element={<VisitPage />} />
            <Route path="/parametres" element={<DisposPage />} />
            <Route path="/parametres/disponibilites" element={<Navigate to="/parametres" replace />} />
            <Route path="/contrats" element={<ContratsPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
      <VersionBadge />
    </BrowserRouter>
  );
}
